
import { defineComponent, PropType } from 'vue';
import { B2CProfileTileModel } from '@/types/B2CcontentServerContract';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';
import Profile from '@/b2c/profile/ui/Profile.vue';

export default defineComponent({
    name: 'B2CProfileTile',
    components: { Profile, BlockMaxWidthHandler },
    props: {
        content: {
            type: Object as PropType<B2CProfileTileModel>,
            required: true,
        },
    },
});
